import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Apollo } from 'apollo-angular';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { LicenciaService } from 'src/app/services/licencia.service';
import { LoginService } from 'src/app/services/login.service';
import { RenovarLicenciaComponent } from 'src/app/components/portal-contratista/licencias/renovar-licencia/renovar-licencia.component';
import moment from 'moment';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-licencias',
  templateUrl: './licencias.component.html',
  styleUrls: ['./licencias.component.scss']
})
export class LicenciasComponent implements OnInit {
  public dataSource: any
  public tableColumns: String[]
  userLog:any
  licencias:any =[]
  dateCaducidad: any
  fechaRenovar: any
  hoy: any
  templateRenovacion: any
  fechaRenovacion: any
  fechaActivacion: any
  fechaLicenciaCaducidad:any
 

  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(public dialog: MatDialog, private apollo: Apollo, 
    private licenciaService:LicenciaService, 
    private loginService: LoginService, 
    private emailService: EmailService) {

    this.tableColumns = ['id','cliente', 'centro' , 'fecha confirmacion', 'fecha caducidad'/* ,'acciones' */]
    this.userLog = loginService.getUserData()
    /* this.fechaRenovar = moment().subtract('days', 30).format() */
    this.hoy = moment(new Date(), 'day').format()
    this.dateCaducidad = new Date()
    this.fechaRenovacion = new Date()
    this.fechaActivacion = new Date()
   }

  ngOnInit(): void {
    this.getLicenciasByContratista() 
   
  }

 dateRenovacion(fecha: any) {
    this.fechaRenovacion = moment(new Date(fecha)).format()
   if (this.fechaRenovacion <= this.hoy) { 
     return true
   } else {
     return false
   } 
    
  }
  exportAsExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Licencias");
    let header = ["Id", "Cliente", "Centro", "Fecha Activación", "Fecha Caducidad"]
    let headerRow = worksheet.addRow(header);

    for (let licencia of this.licencias) {
      let temp = []
      
      // MAPEADO //
      temp.push(licencia["IDLicencia"])
      temp.push(licencia["cliente"] ?  licencia["cliente"]["nombreComercial"]: '')
      temp.push(licencia["centro"] ?  licencia["centro"]["nombre"]: '')

      this.fechaActivacion = moment(licencia.fechaConfirmacion).format('DD-MM-YYYY')
      temp.push(this.fechaActivacion)
     
      this.fechaLicenciaCaducidad = moment(licencia.fechaCaducidad).format('DD-MM-YYYY')
      temp.push(this.fechaLicenciaCaducidad)

      worksheet.addRow(temp)
     
    }

    let fname = "Tabla Licencias"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }

  getLicenciasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.licenciaService.getLicenciasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      
        this.licencias = data.contratista.licencias.filter((licencia:any)=>licencia.IDLicencia)
        this.dataSource = new MatTableDataSource(this.licencias)
        this.dataSource.paginator = this.paginator;     
        this.dataSource.sort = this.sort;

        this.licencias.forEach((element: any) => {
           /* this.dateCaducidad = moment(new Date(element.fechaCaducidad)).subtract('days', 30).format('Y-MM-DD')
          console.log(this.dateCaducidad); */
         
          
          if (element.fechaRenovacion <= this.hoy) {
            this.templateRenovacion = `
                <!DOCTYPE html>
                <html>
                <head>
                <title></title>
                </head>

                <body>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/renovacion_licencias_cabecera_dd1f23c2c4.png' style="width:500px; height:340px; display:block;
                margin:auto;">
                <div style="width:500px; margin:auto">
                <p>Estimado ${element.contratista.nombreComercial},</p>
                <p>Su licencia Nº ${element.IDLicencia} caducará dentro de 30 días.</p>
                <p>Por favor ingrese en la aplicación para realizar el pago de la renovación de la licencia. </p>
                <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
                margin:auto;"></a>
                </div>
                </body>
                </html>`;

                 /*  this.emailService.send(
                    element.contratista.contactoResponsable.mail,
                    'Renovación de licencia Xtensa',
                    this.templateRenovacion
                  ); */
          }
          
        });
        
          }
      )
  }

  openDialog(licencia:any) {
    this.dialog.open(RenovarLicenciaComponent)
    
    this.licenciaService.setLicencia(licencia)
    
    }
}
